<template>
  <v-card>
      <v-card-text>
        <v-layout row>
          <v-flex xs6 sm3>
            <v-text-field label="タイトル" v-model="item.name"  ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs6 sm3>
            <v-checkbox label="本人に表示" v-model="item.isShow.subject" :readonly="false"></v-checkbox>
          </v-flex>
          <v-flex xs6 sm3>
            <v-checkbox label="協力者に表示" v-model="item.isShow.coWorker" :readonly="false"></v-checkbox>
          </v-flex>
        </v-layout>
        <v-layout row　v-if="item.isShow.subject">
          <v-flex xs2 sm1>
            本人
          </v-flex>
          <v-flex xs12 sm9>

            <vue-editor v-model="item.questions.subject" />
          </v-flex>
        </v-layout>
        <v-layout row　v-if="item.isShow.coWorker">
          <v-flex xs2 sm1>
            協力者
          </v-flex>
          <v-flex xs12 sm9>
            <vue-editor v-model="item.questions.coWorker" />
          </v-flex>

        </v-layout>
        <v-layout row>
          <v-flex xs6 sm3>
            <v-text-field label="最小コメント数" type="number" v-model.number="item.maxOfComments"  ></v-text-field>
          </v-flex>
          <v-flex xs6 sm3>
            <v-text-field label="最小コメント数" type="number" v-model.number="item.minOfComments"  ></v-text-field>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-layout row justify-end>
          <v-btn @click="updateQuestion()">保存</v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
</template>
<script>
const columns=["name", "maxOfComments", "minOfComments"]
import { VueEditor } from 'vue2-editor'
export default {
  components: { VueEditor },
  props: {
    item: {},
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {
    updateQuestion() {

      this.$emit("updateCommentQuestion")
    }
  }
}
</script>